export default __webpack_public_path__ + "static/media/legs.e8284841.png";